import { render } from "./betAll.vue?vue&type=template&id=42920384&scoped=true"
import script from "./betAll.vue?vue&type=script&lang=js"
export * from "./betAll.vue?vue&type=script&lang=js"

import "./betAll.vue?vue&type=style&index=0&id=42920384&scoped=true&lang=css"
import "./betAll.vue?vue&type=style&index=1&id=42920384&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/tcd-partnerpage-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42920384"]])

export default __exports__